import React, { RefObject, useEffect } from 'react';
import ReactModal from 'react-modal';

import { TimesRegularIcon } from '../../shared/icons/icons';
import Typography from '../typography/typography';

import styles from './modal.scss';

export interface ModalProps {
  children?: React.ReactNode;
  className?: string;
  heading?: React.ReactNode;
  isOpen: boolean;
  modalContainerRef?: RefObject<HTMLDivElement>;
  onAfterOpen?: () => void;
  onClose: () => void;
  showHeader?: boolean;
  subtitle?: React.ReactNode;
}

ReactModal.setAppElement('#root');
ReactModal.defaultStyles.content = null;
ReactModal.defaultStyles.overlay = null;

function Modal(props: ModalProps) {
  const {
    children,
    className,
    heading,
    isOpen,
    onClose,
    modalContainerRef,
    showHeader = true,
    subtitle,
    ...restProps
  } = props;

  function onRequestClose() {
    const scrollY = window.scrollY;

    if (typeof onClose === 'function') {
      onClose();
      window.scrollTo(0, scrollY);
    }
  }

  useEffect(
    () =>
      // Added this because of the following React Modal issue:
      // https://github.com/reactjs/react-modal/issues/759
      () => {
        document.body.classList.remove('ReactModal__Body--open');
      },
    []
  );

  return (
    <ReactModal
      className={`${className || ''} modal`}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={styles['modal-overlay']}
      {...restProps}
    >
      {showHeader && (
        <header className="modal__header" styleName="header-container">
          <button
            aria-label="modal close button"
            className="modal__header-close-button"
            onClick={onRequestClose}
            styleName="close"
            type="button"
          >
            <TimesRegularIcon styleName="close-icon" />
          </button>
          <div className="modal__header-content" styleName="header">
            {typeof heading === 'string' && (
              <Typography tag="span" variant="H4" weight="black">
                {heading}
              </Typography>
            )}
            {typeof heading === 'function' && heading()}
          </div>
          {typeof subtitle === 'string' && (
            <Typography styleName="subtitle">{subtitle}</Typography>
          )}
          {typeof subtitle === 'function' && subtitle()}
        </header>
      )}

      <div
        className="modal__container"
        ref={modalContainerRef}
        styleName="container"
      >
        {children}
      </div>
    </ReactModal>
  );
}

export default Modal;
